const flattenStudentGrades = ({ assignmentGrades, mappedAssignmentIds }) => {
  const studentAssignmentGrades = {};

  Object.entries(assignmentGrades).forEach(
    ([assignmentId, studentAssignments]) => {
      if (mappedAssignmentIds.includes(assignmentId)) {
        studentAssignments.forEach(({ studentId, ...rest }) => {
          studentAssignmentGrades[studentId] = {
            ...studentAssignmentGrades[studentId],
            [assignmentId]: {
              studentId,
              assignmentId,
              ...rest,
            },
          };
        });
      }
    }
  );

  return studentAssignmentGrades;
};

export default flattenStudentGrades;
